import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

interface Step {
  label: string;
  path?: string;
}

interface WizardStepperProps {
  steps: Step[];
  currentStep: number;
}

export const WizardStepper: React.FC<WizardStepperProps> = ({ steps, currentStep }) => {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      padding: '16px 24px',
      background: 'var(--surface)',
      borderBottom: '1px solid var(--border)',
    }}>
      {steps.map((step, index) => {
        const isDone = index < currentStep;
        const isActive = index === currentStep;
        const isClickable = isDone && !!step.path;
        return (
          <React.Fragment key={step.label}>
            <div
              style={{ display: 'flex', alignItems: 'center', gap: '7px', cursor: isClickable ? 'pointer' : 'default' }}
              onClick={() => isClickable && navigate(step.path!)}
              title={isClickable ? `Go back to ${step.label}` : undefined}
            >
              <div className={`wiz-step-num ${isDone ? 'done' : isActive ? 'active' : 'pending'}`}>
                {isDone ? <Check size={13} strokeWidth={3} /> : <span>{index + 1}</span>}
              </div>
              <span style={{
                fontSize: '12.5px',
                fontWeight: isActive ? 700 : isDone ? 600 : 400,
                color: isActive ? 'var(--text-1)' : isDone ? 'var(--p)' : 'var(--text-3)',
                whiteSpace: 'nowrap',
              }}>
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className={`wiz-step-line${isDone ? ' done' : ''}`} style={{ margin: '0 10px' }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
